import {
  Button,
  type ButtonProps,
  Modal,
} from '@lego/connect-components-react';
import type { ReactNode, RefObject } from 'react';

type BaseModalProps = {
  isOpen: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  title: ReactNode;
  children: ReactNode;
  rightButtonProps: ButtonProps & { text: string };
  modalRef?: RefObject<HTMLDivElement | null>;
  leftButtonText?: string;
  size?: 'small' | 'medium' | 'large';
  onClose: () => void;
};

export const BaseModal = ({
  isOpen,
  triggerRef,
  title,
  children,
  leftButtonText = 'Cancel',
  rightButtonProps,
  modalRef,
  size = 'medium',
  onClose,
}: BaseModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      triggerRef={triggerRef}
      ref={modalRef}
    >
      <Modal.Title>{title}</Modal.Title>
      <Modal.Content>{children}</Modal.Content>
      <Modal.Footer>
        <Button
          onClick={onClose}
          aria-label={leftButtonText}
          appearance={'ghost'}
          variant={'neutral'}
        >
          {leftButtonText}
        </Button>
        <Button {...rightButtonProps}>{rightButtonProps.text}</Button>
      </Modal.Footer>
    </Modal>
  );
};
